import SonoraHintViewState from '../store/schema/SonoraHintViewState';
import { SonoraSuggestionType } from '../store/schema/SonoraSuggestion';
import { isFeatureEnabled } from 'owa-feature-flags';
import isSonoraPluginFileSuggestionsEnabled from './isSonoraPluginFileSuggestionsEnabled';

const createSonoraHintViewState = () => {
    const availableTypes: SonoraSuggestionType[] = [];
    let selectedType: SonoraSuggestionType | undefined;

    if (
        isFeatureEnabled('honeybee-sonora-clipboard') ||
        isFeatureEnabled('honeybee-sonora-systemClipboard')
    ) {
        availableTypes.push(SonoraSuggestionType.Clipboard);
    }

    if (isSonoraPluginFileSuggestionsEnabled()) {
        availableTypes.push(SonoraSuggestionType.File);
    }

    if (isFeatureEnabled('honeybee-sonora-stickyNotes')) {
        availableTypes.push(SonoraSuggestionType.StickyNotes);
    }

    if (availableTypes.length) {
        selectedType = availableTypes[Math.floor(Math.random() * availableTypes.length)];
    }

    const viewState = <SonoraHintViewState>{
        selectedType: selectedType,
        hintNode: undefined,
    };

    return viewState;
};

export default createSonoraHintViewState;
